import { gtm } from 'root/utils/tracking/googleTagManagerDeprecated';
import config from 'root/main/components/navigation/navigation_config.json';
import { GoogleTagManager } from 'root/utils/tracking/GA4/googleTagManager';
import navTracking from 'root/utils/tracking/GA4/navigation/navTracking';

export default function navigationFooter(els) {
    const footer = els[0];
    footer.addEventListener('click', e => {
        if (e.target.hasAttribute(config.navigation_link_attribute)) {
            gtm.footerMenu(e.target).sendEvent('click');
            const GTMObject = navTracking(e.target);
            GTMObject && GoogleTagManager.sendEvent(GTMObject);
        } else if (e.target.closest('[data-footer-link-no-text]')) {
            const parentLink = e.target.closest('[data-footer-link-no-text]');
            gtm.footerMenu(parentLink).sendEvent('click');
        }
    });
}
